import axios from 'axios';

class Service {
  constructor(prefix) {
		let BaseApi = axios.create({
			headers: {}
		});

		window.prefix = prefix;

		let token = document.head.querySelector('meta[name="csrf-token"]');

		this.service = () => {
			BaseApi.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(window.prefix+"token")}`;
			BaseApi.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
			BaseApi.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
			BaseApi.interceptors.response.use(this.handleSuccess, this.handleError);
			return BaseApi;
		}
  }

  handleSuccess(response) {
		return response;
  }

  handleError(error) {
		console.log("Handling Error");
		switch (error.response.status) {
	  	case 401:
				console.log("401 Error",window.prefix);
				localStorage.setItem(window.prefix+"token",false);
				app.config.globalProperties.emitter.emit('logout');
				//alert("Not authenticated");
				break;
	  	case 404:
				break;
	  	default:
			break;
		}
		console.log("Service Error:", error.response);
		return Promise.reject(error)
  }

  redirectTo(document, path) {
		document.location = path
  }

  get(path, payload) {
		return this.service().get(path, {params: payload}).then(
			response => Promise.resolve(response)
		);
  }

  patch(path, payload) {
		return this.service().request({
			method: 'PATCH',
			url: path,
			responseType: 'json',
			data: payload
		}).then(response => Promise.resolve(response));
  }

  post(path, payload) {
		return this.service().request({
			method: 'POST',
			url: path,
			responseType: 'json',
			data: payload
		}).then(response => Promise.resolve(response));
  }
}

export default Service;
